import { motion } from 'framer-motion';

const ContactMap = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold text-black mb-4">
            Nuestra <span className="text-primary-yellow">Oficina</span>
          </h2>
          <p className="text-gray-medium text-lg">
            Visítanos en persona o coordina una reunión con nuestro equipo
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="grid lg:grid-cols-3 gap-8 items-stretch"
        >
          {/* Info Cards */}
          <div className="flex flex-col gap-6">
            {/* Dirección */}
            <div className="bg-white rounded-2xl p-6 shadow-md border border-gray-100 flex items-start space-x-4">
              <div className="w-12 h-12 flex items-center justify-center bg-primary-yellow rounded-xl flex-shrink-0">
                <i className="ri-map-pin-line text-2xl text-black"></i>
              </div>
              <div>
                <h4 className="font-bold text-black mb-1">Dirección</h4>
                <p className="text-gray-medium text-sm leading-relaxed">
                  Monseñor Escrivá de Balaguer 5773<br />
                  Vitacura, Región Metropolitana<br />
                  Santiago, Chile
                </p>
              </div>
            </div>

            {/* Horarios */}
            <div className="bg-white rounded-2xl p-6 shadow-md border border-gray-100 flex items-start space-x-4">
              <div className="w-12 h-12 flex items-center justify-center bg-primary-yellow rounded-xl flex-shrink-0">
                <i className="ri-time-line text-2xl text-black"></i>
              </div>
              <div>
                <h4 className="font-bold text-black mb-1">Horarios</h4>
                <p className="text-gray-medium text-sm leading-relaxed">
                  Lunes a Viernes: 9:00 – 18:00<br />
                  Sábados: 10:00 – 14:00
                </p>
              </div>
            </div>

            {/* Cómo llegar */}
            <div className="bg-black rounded-2xl p-6 shadow-md flex items-start space-x-4">
              <div className="w-12 h-12 flex items-center justify-center bg-primary-yellow rounded-xl flex-shrink-0">
                <i className="ri-navigation-line text-2xl text-black"></i>
              </div>
              <div>
                <h4 className="font-bold text-white mb-1">Cómo llegar</h4>
                <p className="text-gray-400 text-sm leading-relaxed mb-3">
                  Cercano al Metro Escuela Militar (L1). Estacionamiento disponible en el sector.
                </p>
                <a
                  href="https://www.google.com/maps/dir/?api=1&destination=Monse%C3%B1or+Escriv%C3%A1+de+Balaguer+5773,+Vitacura,+Regi%C3%B3n+Metropolitana,+Chile"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="inline-flex items-center space-x-2 bg-primary-yellow text-black px-4 py-2 rounded-full text-sm font-bold hover:bg-yellow-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-map-2-line"></i>
                  <span>Cómo llegar</span>
                </a>
              </div>
            </div>
          </div>

          {/* Google Maps Embed */}
          <div className="lg:col-span-2 rounded-2xl overflow-hidden shadow-xl border border-gray-100 min-h-[420px]">
            <iframe
              title="Ubicación Bala Corp - Monseñor Escrivá de Balaguer 5773, Vitacura"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3329.5!2d-70.5897!3d-33.4012!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662cf2b3b3b3b3b%3A0x0!2sMonse%C3%B1or+Escriv%C3%A1+de+Balaguer+5773%2C+Vitacura%2C+Regi%C3%B3n+Metropolitana%2C+Chile!5e0!3m2!1ses!2scl!4v1700000000000!5m2!1ses!2scl&q=Monse%C3%B1or+Escriv%C3%A1+de+Balaguer+5773,+Vitacura,+Regi%C3%B3n+Metropolitana,+Chile"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '420px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactMap;
